"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var utils_1 = require("./utils");
var Scrollchor = /** @class */ (function (_super) {
    __extends(Scrollchor, _super);
    function Scrollchor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Scrollchor.prototype.simulateClick = function () {
        this.handleClick();
    };
    Scrollchor.prototype.handleClick = function (event) {
        var _a = this.props, beforeAnimate = _a.beforeAnimate, to = _a.to, animate = _a.animate, afterAnimate = _a.afterAnimate, disableHistory = _a.disableHistory;
        if (beforeAnimate)
            beforeAnimate(event);
        if (event)
            event.preventDefault();
        var toNoHash = to.replace(/^#/, "");
        var id = utils_1.animateScroll(toNoHash, animate);
        if (id) {
            if (disableHistory) {
                utils_1.updateHistory();
            }
            else {
                utils_1.updateHistory(id);
            }
            if (afterAnimate)
                afterAnimate(event);
        }
    };
    Scrollchor.prototype.render = function (_a) {
        var _this = this;
        var to = _a.to, children = _a.children;
        return children ? (preact_1.h("a", { href: to, onClick: function (e) { return _this.handleClick(e); } }, children)) : null;
    };
    return Scrollchor;
}(preact_1.Component));
exports.default = Scrollchor;
//# sourceMappingURL=scrollchor.js.map